export default __webpack_public_path__ + "static/pizza-presentation-00c3cf20473e30564096f723901fd967.png";